import React, { memo, useMemo } from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import classnames from 'classnames';

import KeyMomentsCarousel from './KeyMomentsCarousel';
import { filterCarouselKeyMoments } from './utils';

import './KeyMoments.scss';

function KeyMomentsContainer({
  enabled,
  items,
  selectedId,
  unavailableIds,
  isVisible,
  immersive,
  onCenterChange,
  onSelect,
  onCarouselDismiss,
  className,
}) {
  const { formatMessage } = useIntl();

  const carouselItems = useMemo(
    () => filterCarouselKeyMoments(items),
    [items],
  );

  const labels = useMemo(() => ({
    goal: formatMessage({ id: 'keyMoments.category.goal', defaultMessage: 'Goal' }),
    yellowCard: formatMessage({ id: 'keyMoments.category.yellowCard', defaultMessage: 'Yellow Card' }),
    redCard: formatMessage({ id: 'keyMoments.category.redCard', defaultMessage: 'Red Card' }),
    substitution: formatMessage({ id: 'keyMoments.category.substitution', defaultMessage: 'Substitution' }),
    matchStatus: formatMessage({ id: 'keyMoments.category.matchStatus', defaultMessage: 'Status' }),
    unavailable: formatMessage({ id: 'keyMoments.unavailable', defaultMessage: 'Indisponível' }),
  }), [formatMessage]);

  if (!enabled || carouselItems.length === 0) return null;

  return (
    <div
      className={classnames(
        'dtv-web-c-key-moments',
        'dtv-common-c-key-moments',
        'dtv-common-c-key-moments--open',
        isVisible && 'dtv-web-c-key-moments--visible',
        immersive && 'dtv-web-c-key-moments--immersive',
        className,
      )}
    >
      <KeyMomentsCarousel
        immersive={immersive}
        items={carouselItems}
        selectedId={selectedId}
        unavailableIds={unavailableIds}
        labels={labels}
        onCarouselDismiss={onCarouselDismiss}
        onCenterChange={onCenterChange}
        onSelect={onSelect}
      />
    </div>
  );
}

KeyMomentsContainer.propTypes = {
  enabled: PropTypes.bool,
  items: PropTypes.arrayOf(PropTypes.shape({
    incidenceId: PropTypes.number.isRequired,
  })),
  selectedId: PropTypes.number,
  unavailableIds: PropTypes.instanceOf(Set),
  isVisible: PropTypes.bool,
  immersive: PropTypes.bool,
  onCenterChange: PropTypes.func,
  onSelect: PropTypes.func,
  onCarouselDismiss: PropTypes.func,
  className: PropTypes.string,
};

KeyMomentsContainer.defaultProps = {
  enabled: false,
  items: [],
  selectedId: undefined,
  unavailableIds: undefined,
  isVisible: false,
  immersive: false,
  onCenterChange: undefined,
  onSelect: undefined,
  onCarouselDismiss: undefined,
  className: '',
};

export default memo(KeyMomentsContainer);
